import L from "leaflet";
import marker from "@/icons/location-icon.svg";
import "leaflet/dist/leaflet.css";

document.addEventListener("DOMContentLoaded", () => {
  const mapContainer = document.querySelector("#map");
  if (!mapContainer) return;

  const pointElements = mapContainer.querySelectorAll(
    ".map-marker, .map-point"
  );
  if (!pointElements.length) return;

  const icon = L.icon({
    iconUrl: marker,
    iconSize: [30, 80],
    iconAnchor: [22, 94],
    shadowAnchor: [4, 62],
    popupAnchor: [-3, -76],
  });

  // Use the first point for initial center
  const firstPoint = pointElements[0];
  const lat = parseFloat(firstPoint.dataset.lat);
  const lng = parseFloat(firstPoint.dataset.lng);
  const map = L.map("map", {
    maxZoom: 16,
    scrollWheelZoom: false,
    touchZoom: false,
    keyboard: true,
    keyboardPanDelta: 80,
  }).setView([lat, lng], 10);

  L.tileLayer(
    "https://services.arcgisonline.com/arcgis/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}"
  ).addTo(map);

  // Esri reference (labels) layer, free and no API key. CARTO's tiles now
  // require a key and watermark "API KEY REQUIRED".
  L.tileLayer(
    "https://services.arcgisonline.com/arcgis/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}"
  ).addTo(map);

  const markers = [];
  pointElements.forEach((el, index) => {
    const lat = parseFloat(el.dataset.lat);
    const lng = parseFloat(el.dataset.lng);
    const popupText = el.dataset.popup || "We are here!";
    if (!isNaN(lat) && !isNaN(lng)) {
      const marker = L.marker([lat, lng], {
        icon,
        title: `Location ${index + 1}`,
        alt: `Location marker ${index + 1}`,
        keyboard: true,
      }).addTo(map);
      marker.bindPopup(popupText);
      markers.push(marker);
    }
  });

  if (markers.length > 1) {
    const group = L.featureGroup(markers);
    map.fitBounds(group.getBounds().pad(0.2));
  }
});
